import { showPlayButton } from '../state/ui-store';
import { onPlayPauseStateChange } from './on-play-pause-state-change';

export const continueGoviePlayback = () => {
  showPlayButton();
  onPlayPauseStateChange();
};
